<template>
    <div class="container">
        <AppSection v-if="primaryArticle">
            <template #body>
                <ArticleCard v-bind="primaryArticle" large/>
            </template>
        </AppSection>

        <ArticlesSection
            v-if="topArticleList.length"
            :params="{...params, ...{items: topArticleList, pagination: null}}"
        />

        <AppSection v-if="params.banner">
            <template #body>
                <StoryCard v-bind="params.banner"/>
            </template>
        </AppSection>

        <ArticlesSection :params="{...params, ...{isSlider: false}}" />

    </div>
</template>

<script>
import {computed} from "vue";
import ArticlesSection from "../components/sections/ArticlesSection";
import ArticleCard from "../components/cards/ArticleCard";
import AppSection from "../components/AppSection";
import StoryCard from "../components/cards/StoryCard";

export default {
    name: "BlogContainer",
    props: ['params'],
    components: {StoryCard, AppSection, ArticleCard, ArticlesSection},
    setup(props) {
        // первой идет главная статья (на всю ширину)
        const primaryArticle = computed(() => {
          if(props.params) {
            if(props.params.topArticleList) {
              if(props.params.topArticleList[0]) {
                return props.params?.topArticleList[0];
              }
            }
          }
          return false;
        })

        // за главной статьей идут остальные
        const topArticleList = computed(() => {
            if (Array.isArray(props.params?.topArticleList) && props.params?.topArticleList.length > 1) {
                const articles = [...props.params.topArticleList]
                articles.shift()
                return articles
            }

            return []
        })

        return {
            primaryArticle,
            topArticleList
        }
    }
}
</script>

<style scoped>

</style>